import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  fetchCustomJwt,
  type TokenType,
} from '@/services/permissions/permissions-service';

export function customJwtQuery(tokenType: TokenType) {
  return {
    queryKey: ['customJwt', tokenType],
    queryFn: () => fetchCustomJwt(tokenType),
    staleTime: Infinity,
  } satisfies UseQueryOptions;
}

export function useCustomJwtQuery(tokenType: TokenType) {
  return useQuery(customJwtQuery(tokenType));
}
